import { create } from 'zustand'

export interface AuthUser {
  userId: string
  email: string
  /** Display role (custom:role, else the first group). */
  role: string
  /** Every Cognito group plus custom:role, normalized. */
  groups: string[]
}

interface AuthState {
  user: AuthUser | null
  isLoading: boolean
  isAuthenticated: boolean
  setUser: (user: AuthUser | null) => void
  setLoading: (loading: boolean) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: true,
  isAuthenticated: false,

  setUser: (user) => set({ user, isAuthenticated: !!user, isLoading: false }),

  setLoading: (isLoading) => set({ isLoading }),

  logout: () => {
    set({ user: null, isAuthenticated: false, isLoading: false })
    localStorage.removeItem('idToken')
    localStorage.removeItem('accessToken')
  },
}))
